import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { GetHaloPackageDto, GetHaloPackageResp } from './get-halo-package.type';
import { PackageRepository } from '@data/repositories/package.repository';
import { catchError, Observable, throwError } from 'rxjs';
import { ErrorMessageService } from '@shared/services/error-message/error-message.service';

@Injectable({
    providedIn: 'root'
})

export class GetHaloPackageUsecase implements UseCase<GetHaloPackageDto, GetHaloPackageResp> {
    private readonly packageRepository = inject(PackageRepository);
    private readonly errorMessageService = inject(ErrorMessageService);

    execute(params: GetHaloPackageDto): Observable<GetHaloPackageResp> {
        return this.packageRepository.GetHaloPackage(params).pipe(
            catchError((error) => {
                const {status_code, msisdn} = error;
                return throwError(()=> this.errorMessageService.getErrorMessage(status_code, msisdn));
            })
        );
    }
}